import get from 'lodash/get';

import { SORT_OPTION } from '@/constants/search';
import { isObject } from '@/utility/objects';

import { ActiveOptimizelyDecision } from '.';

// Refine optimizely variable into a module order variable
const isOrderVar = (optVar: unknown): optVar is { sort_order: { sort_order: SORT_OPTION[] } } => {
  if (
    isObject(optVar) &&
    isObject(optVar.sort_order) &&
    Array.isArray(optVar.sort_order.sort_order)
  )
    return true;
  return false;
};

export const getSortLogicFromOptimizely = (
  decision?: ActiveOptimizelyDecision | null,
): SORT_OPTION[] => {
  const defaultSortLogic: SORT_OPTION[] = [
    SORT_OPTION.RECOMMENDED,
    SORT_OPTION.PRICE_HIGH_TO_LOW,
    SORT_OPTION.PRICE_LOW_TO_HIGH,
    SORT_OPTION.CLOSEST_FIRST,
    SORT_OPTION.TOP_RATED,
  ];
  if (!decision) return defaultSortLogic;
  const { variables } = decision;

  const sortOrder = isOrderVar(variables) ? variables.sort_order.sort_order : defaultSortLogic;

  return sortOrder;
};

const isOrderNameVar = (optVar: unknown): optVar is { sort_names: { sort_names: string[] } } => {
  return Array.isArray(get(optVar, 'sort_names.sort_names', null));
};

export const getSortLogicNamesFromOptimizely = (
  decision?: ActiveOptimizelyDecision | null,
): string[] | null => {
  if (!decision) return null;
  const { variables } = decision;
  const sortOrderNames = isOrderNameVar(variables) ? variables.sort_names.sort_names : null;
  const sortOrder = isOrderVar(variables) ? variables.sort_order.sort_order : null;
  if (!sortOrderNames || !sortOrder) {
    return null;
  }
  if (sortOrder.length != sortOrderNames.length) {
    return null;
  }
  return sortOrderNames;
};
